export interface EquipmentSettingsModel {
    equipmentGuid: string;
    settingSections: SectionModel[];
}

export interface SectionModel {
    name: string;
    guid: string;
    sizeRatio: PredefinedSize;
    request: RequestInfo;
    params?: SectionParams;
}

export interface RequestInfo {
    url: string;
    params: any;
    destination: PredefinedDestination;
    paramsToSet?: any;
    pathVariableToSet?: any | Map<number, any>;
    mapParamNames?: any | Map<string, string>;
    urlParamsToSet?: string[];
    patchOperations: any | Map<number, any>;
    method?: PredefinedMethod;
    valueBasedRequests?: any | Map<string, RequestInfo>;
}

export interface SectionContent {
    contentType: SectionContentType;
    content: SectionItem[];
}

export const ITEM_EQUIPMENT_LAST_VISIT_DATE = "b62e6828-16b7-42bd-bfd1-247aeea88a6d";

export enum PredefinedSize {HALF = "HALF", FULL = "FULL"}

export enum PredefinedDestination {VEBOX = "WEB", RESTAPI = "RESTAPI"}

export enum PredefinedMethod {POST = "POST", DELETE = "DELETE", PUT = "PUT", PATCH = "PATCH"}

export interface SectionParams {
    htmlContainerID?: string;
    equipmentGuid?: string;
    editable?: boolean;
}

export interface SectionItem {
    name: string;
    guid: string;
    equipmentGuid: string;
    type: SectionItemType;
    action: RequestInfo;
    data: SingleData | GroupData | Command;
    updateInfo?: UpdateInfo;
    confirmationDialog?: ConfirmationDialogInfo;
}

export interface UpdateInfo {
    updatingDescriptionLayout: string;
    values: any | Map<number, string>;
    equipmentGuid: string;
    cancelable: boolean;
}

export interface ConfirmationDialogInfo {
    title: string;
    description: string;
    question: string;
    optionsIdenfificator?: string;
    options?: any | Map<number, ConfirmationDialogOption>;
    yesButton?: string;
    noButton?: string;
    reasons?: ConfirmationDialogOption[];
}

export interface ConfirmationDialogOption {
    description: string;
    paramName: string;
    paramValue: string;
}

export enum SectionContentType { ITEMS_LIST = "ITEMS_LIST"}

export enum SectionItemType {
    SINGLE = "SINGLE",
    GROUP = "GROUP",
    COMMAND = "COMMAND",
    COMMAND_WITH_VALUE = "COMMAND_WITH_VALUE"
}

export interface SingleData {
    type: DataType;
    value: TextValue | NumberValue | SelectValue;
}

export enum DataType {
    TEXT = "TEXT",
    EDITABLE_TEXT = "EDITABLE_TEXT",
    NUMBER = "NUMBER",
    EDITABLE_NUMBER = "EDITABLE_NUMBER",
    SELECT = "SELECT",
    SELECT_WITH_ADDITIONAL_INFORMATION = "SELECT_WITH_ADDITIONAL_INFORMATION",
}

export interface TextValue {
    value?: string;
    additionalData?: any | ValueAdditionalData;
}

export interface NumberValue {
    value?: number;
    additionalData?: any | ValueAdditionalData;
}

export interface SelectValue {
    value?: string;
    options: any | Map<string, string>;
    additionalData?: any | Map<string | number, ValueAdditionalData>;
}

export interface ValueAdditionalData {
    color?: string;
    unitOfMeasure?: string;
    confirmationDialog?: ConfirmationDialogInfo;
    reason?: string;
    reasonTextColor: string;
    canBeEmpty?: boolean;
}

export interface GroupData {
    layout: string;
    values: any | Map<string, SingleData>;
}

export interface Command {
    hrefIcon: string;
    editable?: boolean
}
